function Footer(){
 return (
   <section>
     <div className="handmade">
       <p>
         Thanks for reading!  <em> updated @ 07th January 2024</em> 
       </p>
     </div>
   </section>
 );

}

export default Footer;